import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface DeckleImageProps {
    src: string
    alt: string
    sizes: string
    className?: string
    frameClassName?: string
    imageClassName?: string
    shape?: 'portrait' | 'landscape'
    priority?: boolean
    lift?: boolean
}

// A photograph cut like a handmade sheet: torn deckled edges and a soft shadow on the paper below
const DeckleImage: FC<DeckleImageProps> = ({
    src,
    alt,
    sizes,
    className,
    frameClassName,
    imageClassName,
    shape = 'portrait',
    priority = false,
    lift = true
}): ReactNode => {
    return (
        <div className={cn(lift && 'paper-lift', className)}>
            <div
                className={cn(
                    'relative overflow-hidden bg-paper-deep',
                    shape === 'portrait' ? 'deckle aspect-[4/5]' : 'deckle-wide aspect-[3/2]',
                    frameClassName
                )}
            >
                <Image
                    src={src}
                    alt={alt}
                    fill
                    priority={priority}
                    sizes={sizes}
                    quality={82}
                    className={cn('object-cover', imageClassName)}
                />
            </div>
        </div>
    )
}

export default DeckleImage
